import { styled } from '@material-ui/core';

export const List = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0',
});
